import { motion, AnimatePresence } from "framer-motion";
import React, { useRef } from "react";
import { AiFillHome } from "react-icons/ai";
import { FaStickyNote } from "react-icons/fa";
import { BsFillTelephoneFill, BsFillBagFill } from "react-icons/bs";
import { IoIosInformationCircle } from "react-icons/io";
import "./Hamburger.scss";
import { Link } from "react-scroll";

const Hamburger = ({ toggle, setToggle }) => {
  const ref = useRef(null);
  let style = {
    display: "block",
  };
  let unstyle = {
    display: "none",
  };

  return (
    <AnimatePresence>
      {toggle && (
        <motion.aside
          key={toggle}
          initial={{ top: 100, opacity: 0 }}
          animate={{ top: 100, opacity: 1 }}
          exit={{ top: 90, opacity: 0 }}
          transition={{
            duration: 0.1,
            opacity: { ease: "linear" },
          }}
          ref={ref}
          style={toggle ? style : unstyle}
          className="hamburger-menu"
        >
          <div className="content">
            <ul>
              <li title="Home">
                <Link
                  to="home"
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={50}
                  onClick={() => setToggle(false)}
                >
                  <AiFillHome />
                </Link>
              </li>
              <li title="About">
                <Link
                  to="about"
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={50}
                  onClick={() => setToggle(false)}
                >
                  <IoIosInformationCircle />
                </Link>
              </li>
              <li title="Resume">
                <Link
                  to="resume"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={50}
                  onClick={() => setToggle(false)}
                >
                  <FaStickyNote />
                </Link>
              </li>
              <li title="Portfolio">
                <Link
                  to="portfolio"
                  spy={true}
                  smooth={true}
                  offset={-60}
                  duration={50}
                  onClick={() => setToggle(false)}
                >
                  <BsFillBagFill />
                </Link>
              </li>
              <li title="Contact">
                <Link
                  to="contact"
                  spy={true}
                  smooth={true}
                  offset={-60}
                  duration={50}
                  onClick={() => setToggle(false)}
                >
                  <BsFillTelephoneFill />
                </Link>
              </li>
            </ul>
          </div>
        </motion.aside>
      )}
    </AnimatePresence>
  );
};

export default Hamburger;
